import { render } from "./TDBG18.vue?vue&type=template&id=49ac0670&scoped=true"
import script from "./TDBG18.vue?vue&type=script&lang=js"
export * from "./TDBG18.vue?vue&type=script&lang=js"

import "./TDBG18.vue?vue&type=style&index=0&id=49ac0670&scoped=scoped&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ac0670"]])

export default __exports__